<template>
  <v-card>
    <v-card-title>
      {{ $t("formula.template.title") }}
    </v-card-title>

    <v-form
      :lazy-validation="false"
      @submit.prevent="handleSubmit"
      ref="templateForm"
      class="d-flex justify-space-between align-center"
      style="width: 100%"
    >
      <v-card-text>
        <v-text-field
          :label="$t('formula.fields.name')"
          autocomplete="off"
          type="text"
          v-model="localFormulaTemplate.name"
          :rules="[rules.name]"
        />

        <v-text-field
          :label="$t('formula.fields.description')"
          autocomplete="off"
          type="text"
          v-model="localFormulaTemplate.description"
        />

        <v-textarea
          :label="$t('formula.fields.formula')"
          autocomplete="off"
          type="text"
          outlined
          v-model="localFormulaTemplate.value"
          :rules="[rules.name]"
          :hint="$t('formula.fields.formulaHint')"
        />

        <v-switch
          v-model="localFormulaTemplate.awaitAllInput"
          :label="$t('formula.form.awaitAllInput')"
        />

        <v-switch
          v-model="localFormulaTemplate.isGlobal"
          :label="$t('formula.fields.isGlobal')"
        />
        <v-btn color="primary" type="submit" text>
          {{ $t("common.save") }}
        </v-btn>
      </v-card-text>
    </v-form>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { defaultFormulaTemplateFields } from "@/_helpers/formulaHelper";

export default {
  name: "CreateFormulaTemplateForm",
  props: {
    formulaTemplateId: {
      type: String,
      default: () => "",
    },
  },

  emits: ["update"],

  computed: {
    ...mapGetters("formulas", [
      "getFormulaTemplateById",
      "getFormulaTemplateByName",
    ]),
  },

  data() {
    return {
      valid: false,
      localFormulaTemplate: {},
      rules: {
        name: (v) => !!v || this.$t("validation.requiredSingle"),
      },
    };
  },

  methods: {
    ...mapActions("formulas", ["createOrUpdateFormulaTemplate"]),
    ...mapActions("alert", ["success", "error"]),

    async handleSubmit() {
      if (!this.$refs.templateForm.validate()) return;

      let template = await this.getFormulaTemplateByName(
        this.localFormulaTemplate.name
      );
      if (
        template != undefined &&
        template.formulaTemplateId !=
          this.localFormulaTemplate.formulaTemplateId
      ) {
        this.error(this.$t("formula.errors.duplicateNames"));
        return;
      }

      try {
        (await this.createOrUpdateFormulaTemplate(this.localFormulaTemplate))
          ? this.success(this.$t("common.updated"))
          : this.error(this.$t("common.error"));
      } catch (error) {
        console.error(error);
      }
      this.$emit("update");
    },
  },

  created() {
    let template = this.getFormulaTemplateById(this.formulaTemplateId);
    this.localFormulaTemplate =
      template != undefined ? template : defaultFormulaTemplateFields;
  },

  watch: {
    formulaTemplateId: {
      handler(value) {
        let template = this.getFormulaTemplateById(value);
        this.localFormulaTemplate =
          template != undefined ? template : defaultFormulaTemplateFields;
        this.$refs.templateForm.resetValidation();
      },
      deep: true,
    },
  },
};
</script>
